import { PipelinePastProvision } from '@/types/streams/pipeline'

import { Column, COLUMN_CELL_TYPE, Filter } from '../table/base'
import { formatDateTime } from './utils'

export const PIPELINE_PAST_PROVISION_HEADERS: Column<PipelinePastProvision>[] = [
  { id: 'eventId', label: 'Event ID', type: COLUMN_CELL_TYPE.TEXT, sortAttribute: 'eventId' },
  {
    id: 'eventTitle',
    label: 'Event Title',
    type: COLUMN_CELL_TYPE.TEXT,
    sortAttribute: 'eventTitle'
  },
  {
    id: 'eventStartTime',
    label: 'Start Date / Time',
    type: COLUMN_CELL_TYPE.COMPONENT,
    render: formatDateTime
  },
  {
    id: 'eventEndTime',
    label: 'End Date / Time',
    type: COLUMN_CELL_TYPE.COMPONENT,
    render: formatDateTime
  },
  { id: 'pipelineKey', label: 'Pipeline Key', type: COLUMN_CELL_TYPE.NUMBER }
]

export const pipelinePastProvisionFilters: Filter<PipelinePastProvision>[] = [
  {
    paramName: 'eventId',
    type: 'freeTextSearch',
    filterOptions: (item, value) => {
      return (
        item.eventId?.toString().includes(value) ||
        item.eventTitle?.toString().toLowerCase().includes(value.toLowerCase())
      )
    }
  }
]
